export default "__VITE_ASSET__CwLbCPbh__"